import { toastr } from "react-redux-toastr";
import Api from "../../utils/config/api";
import { setUserProperty } from "../../utils/config/analytics";
import { getFullImageUrl } from "../../utils/constants/constants";
import {
  SET_BUSINESS_DETAILS,
  SET_BUSINESS_ADDRESS,
  SET_ALL_STORES,
  RESET_STORE,
  SET_CUSTOMER_LIST_STATUS,
  SET_ACTIVE_STORE_NUM,
} from "../types";

export const setStoreAddressCall = (data, id) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.post("/v1/stores/" + id, data)
      .then((res) => {
        dispatch({
          type: SET_BUSINESS_ADDRESS,
          payload: res.data,
        });

        return resolve(res.data.payload.id);
      })
      .catch((err) => {
        err?.response?.status !== 401 &&
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );
        return reject(err);
      });
  });
};

export const dummyCallForPage3 = (id) => () => {
  return new Promise((resolve, reject) => {
    Api.post("/v1/stores/" + id, {
      page: 3,
      brand_info: {
        logo: "test",
        banner_image: "test",
      },
    })
      .then(() => {
        return resolve("store address added successfully");
      })
      .catch((err) => reject(err));
  });
};

export const setAllStoreAsActive =
  (groupName, activeStores, activeGrowthStores) => (dispatch) => {
    const firstActiveStore = activeStores?.[0];
    const firstActiveGrwthStore = activeGrowthStores?.[0];

    const firstActiveStoreId = firstActiveStore?.id || firstActiveStore?._id;
    const firstActiveGrwthStoreId =
      firstActiveGrwthStore?.id || firstActiveGrwthStore?._id;

    dispatch(
      setBusinessDetails({
        type: "group",
        allStores: true,
        logo: getFullImageUrl(
          firstActiveGrwthStore?.logo || firstActiveStore?.logo
        ),
        name: groupName || "",
        store_id: firstActiveGrwthStoreId || firstActiveStoreId,
        groupId: firstActiveGrwthStore?.group || firstActiveStore?.group,
      })
    );
  };

const groupAccountSuccessAction =
  (allstores, groupName, isPrimaryAccount) => (dispatch) => {
    if (groupName?.length > 0) setUserProperty("group_name", groupName);

    dispatch({
      type: SET_ALL_STORES,
      payload:
        allstores?.length > 0
          ? allstores?.map((store) =>
              store?.logo?.length > 0
                ? {
                    ...store,
                    logo: getFullImageUrl(store?.logo),
                  }
                : store
            )
          : allstores,
    });

    if (allstores?.length === 0 && isPrimaryAccount) {
      window.location.replace("/onboarding/step-1");
    } else {
      const activeStores = allstores?.filter((store) => store?.is_active);
      const activeGrowthStores = activeStores?.filter(
        (store) => store?.plan === "growth"
      );
      const mainStore = allstores?.find((store) => store?.onboarding_id);
      const mainStoreId = mainStore?.id || mainStore?._id;

      const firstActiveStore = activeStores?.[0];

      const firstActiveStoreId = firstActiveStore?.id || firstActiveStore?._id;

      if (activeStores?.length > 1) {
        dispatch(
          setAllStoreAsActive(groupName, activeStores, activeGrowthStores)
        );
        dispatch(setNumOfActiveStoreStatus(true));
      } else if (activeStores?.length === 1) {
        dispatch(setNumOfActiveStoreStatus(false));
        if (firstActiveStoreId?.length > 0)
          dispatch(setCurrentStore(firstActiveStoreId));
      } else {
        dispatch(setNumOfActiveStoreStatus(false));
        if (mainStoreId?.length > 0 || firstActiveStoreId?.length > 0)
          dispatch(setCurrentStore(mainStoreId || firstActiveStoreId));
        if (activeStores?.length === 0)
          dispatch(setBusinessDetails({ noActiveStore: true }));
      }
    }
  };

export const getAllStoreDetails =
  (groupId, groupName, teamMemberId) => (dispatch) => {
    return new Promise((resolve, reject) => {
      if (groupId) {
        dispatch(setNumOfActiveStoreStatus(false));
        if (teamMemberId?.length > 0) {
          Api.get(`/v1/team-invite/custom-users/stores/${teamMemberId}`)
            .then((res) => {
              dispatch(
                groupAccountSuccessAction(res?.data?.payload, groupName, false)
              );

              return resolve(true);
            })
            .catch((err) => {
              err?.response?.status !== 401 &&
                toastr.error(
                  "Error",
                  err?.response?.data?.message || "Something went wrong!"
                );
              return reject(err);
            });
        } else {
          Api.get(`/v1/groups/stores/${groupId}`)
            .then((res) => {
              dispatch(
                groupAccountSuccessAction(res?.data?.payload, groupName, true)
              );
              return resolve(true);
            })
            .catch((err) => {
              err?.response?.status !== 401 &&
                toastr.error(
                  "Error",
                  err?.response?.data?.message || "Something went wrong!"
                );
              return reject(err);
            });
        }
      } else {
        Api.get("/v1/stores")
          .then((res) => {
            let allstores = res.data.payload?.results;
            dispatch(setNumOfActiveStoreStatus(false));
            dispatch({
              type: SET_ALL_STORES,
              payload: allstores,
            });
            if (allstores?.length === 0) {
              window.location.replace("/onboarding/step-1");
            } else {
              const firstStore = allstores[0];
              const firstStoreName = firstStore?.name;
              const firstStoreId = firstStore?.id || firstStore?._id;
              if (firstStoreId?.length > 0) {
                dispatch(setCurrentStore(firstStoreId));
                setUserProperty("store_name", firstStoreName);
              }
            }
            return resolve(true);
          })
          .catch((err) => {
            err?.response?.status !== 401 &&
              toastr.error(
                "Error",
                err?.response?.data?.message || "Something went wrong!"
              );
            return reject(err);
          });
      }
    });
  };

export const updateStore = (data, storeId) => () => {
  return new Promise((resolve, reject) => {
    Api.patch("/v1/stores/" + storeId, data)
      .then(() => {
        return resolve("done");
      })
      .catch((err) => {
        if (err?.response?.status === 422) {
          return reject(err?.response?.data?.errors);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const toggleStoreActivation = (storeId, data) => () => {
  return new Promise((resolve, reject) => {
    Api.put(`/v1/groups/${storeId}`, data)
      .then((res) => {
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        err?.response?.status !== 401 &&
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );
        return reject(err);
      });
  });
};

export const setNumOfActiveStoreStatus = (data) => (dispatch) => {
  dispatch({
    type: SET_ACTIVE_STORE_NUM,
    payload: data,
  });
};

export const setBusinessDetails = (data) => (dispatch) => {
  dispatch({
    type: SET_BUSINESS_DETAILS,
    payload: data,
  });
};

export const setCurrentStore = (storeId) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/stores/${storeId}`)
      .then((res) => {
        const {
          id,
          name,
          logo,
          pos,
          industry,
          category,
          address,
          type,
          bills_ingest_platform,
        } = res.data;

        const groupId = res.data?.group;
        const groupName = res.data?.group_name || "";
        const otpChannels = res.data?.redemption_otp_channels ?? {};

        const disabledStoreIds = [];

        if (disabledStoreIds?.includes(storeId))
          dispatch(toggleCustomerListStatus(true));
        else dispatch(toggleCustomerListStatus(false));

        let payload = {
          store_id: id,
          name,
          logo,
          type,
          address,
          otpChannels,
          pos: pos?.type,
          industry: industry?.value,
          industryObj: industry,
          categoryObj: category,
          bills_ingest_platform,
        };

        if (groupId) payload.groupId = groupId;
        if (pos?.other) payload.otherPos = pos?.other;
        if (groupName?.length > 0) payload.groupName = groupName;

        dispatch({
          type: SET_BUSINESS_DETAILS,
          payload: payload,
        });

        localStorage.setItem("storeId", id);

        return resolve({ store_id: id });
      })
      .catch((err) => {
        err?.response?.status !== 401 &&
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );
        return reject(err);
      });
  });
};

export const toggleCustomerListStatus = (status) => (dispatch) => {
  dispatch({
    type: SET_CUSTOMER_LIST_STATUS,
    payload: status,
  });
};

export const getCashierCredsOfStore = (storeId) => () => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/cashier/${storeId}`)
      .then((res) => {
        let cashiers = res.data.payload?.results;
        if (cashiers?.length > 0) {
          const { username, password } = cashiers[0];

          return resolve({ username, password });
        }
        return resolve({});
      })
      .catch((err) => {
        err?.response?.status !== 401 &&
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );
        return reject(err);
      });
  });
};

export const isPosIntegrated = (storeId) => () => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/stores/${storeId}/has-started-business`)
      .then((res) => {
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        return reject(err);
      });
  });
};

export const resetStore = () => (dispatch) => {
  dispatch({
    type: RESET_STORE,
  });
};
